import React, { useEffect, useState } from "react";
import { graphql } from "gatsby";
// Import Components
import Seo from "../../../components/Seo";
import ArchiveContent from "../../../components/blocks/archive/ArchiveContent";
import CulturalTourContent from "../../../components/blocks/archive/CulturalTourContent";
import dayjs from "dayjs";

/** Render Page */
const CulturalTourArchivePage = ({ data }) => {
  // console.log(
  //   "🚀 ~ file: CulturalTourArchivePage.js:23 ~ CulturalTourArchivePage ~ data:",
  //   data
  // );

  const results = data.culturalTours.nodes;

  const getNumberOfResults = (name, type) => {
    if (type === "city") {
      return results.filter((tour) =>
        tour.includedCities.some((city) => city.name === name)
      ).length;
    }
    if (type === "country") {
      return results.filter((tour) =>
        tour.includedCountries.some((country) => country.name === name)
      ).length;
    }
    if (type === "region") {
      return results.filter((tour) =>
        tour.includedRegions.some((region) => region.name === name)
      ).length;
    }
    if (type === "theme") {
      return results.filter((tour) =>
        tour.themeTags?.themeTags?.tag?.some((tag) => tag.label === name)
      ).length;
    }
    if (type === "departureMonth") {
      return results.filter((tour) =>
        tour.darwinDepartureDates.some((date) => {
          return (
            dayjs(date.landonlydeparturedate).format("MMMM YYYY") === name &&
            (date.departuresStatus === "On Request" ||
              date.departurestatus === "Available" ||
              (date.departurestatus === "On Sale" &&
                dayjs(date.landonlydeparturedate).isAfter(dayjs())))
          );
        })
      ).length;
    }
    if (type === "artist") {
      return name.tours.length;
    }
    if (type === "tourLeader") {
      return name.tours.length;
    }
  };

  const [filterableData, setFilterableData] = useState([]);

  useEffect(() => {
    // Filter out results that don't have themeTags. Remove it when all results have themeTags
    const resultsWithThemeTags = results

      .filter((el) => el.themeTags !== null)
      .filter((el) => el.themeTags.themeTags !== null)
      .filter((el) => el.themeTags.themeTags.tag.length > 0);
    let resultsIds = results.map((el) => el._id);
    const artists = [
      ...new Set(
        data.artists.nodes
          .filter((artist) => {
            if (artist.tours.length > 0) {
              if (artist.tours.some((tour) => resultsIds.includes(tour._id))) {
                let tourIds = artist.tours.map((tour) => tour._id);
                return { ...artist, tours: tourIds };
              }
            }
          })
          .flat()
      ),
    ].map((item) => {
      return {
        name: item.title,
        isChecked: false,
        tours: item.tours,
        number: getNumberOfResults(item, "artist"),
      };
    });

    const tourLeaders = [
      ...new Set(
        data.tourLeaders.nodes
          .filter((leader) => {
            if (leader.tours.length > 0) {
              if (leader.tours.some((tour) => resultsIds.includes(tour._id))) {
                let tourIds = leader.tours.map((tour) => tour._id);
                return {
                  ...leader,
                  tours: tourIds,
                };
              }
            }
          })
          .flat()
      ),
    ].map((item) => {
      return {
        name: item.title,
        isChecked: false,
        tours: item.tours,
        number: getNumberOfResults(item, "tourLeader"),
      };
    });

    const getMonthOrder = (month) => {
      const MONTHS = {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,
      };
      return MONTHS[month.split(" ")[0]];
    };

    const departureMonths = [
      ...new Set(
        results
          .map((tour) => {
            if (tour.darwinDepartureDates.length > 0) {
              let datesArr = tour.darwinDepartureDates.filter(
                (date) =>
                  date.departuresStatus === "On Request" ||
                  date.departurestatus === "Available" ||
                  (date.departurestatus === "On Sale" &&
                    dayjs(date.landonlydeparturedate).isAfter(dayjs()))
              );
              let stringsArr = [];
              datesArr.map((date) => {
                stringsArr.push(
                  `${dayjs(date.landonlydeparturedate).format("MMMM")} ${dayjs(
                    date.landonlydeparturedate
                  ).format("YYYY")}`
                );
              });

              if (
                stringsArr.length > 0 &&
                stringsArr !== undefined &&
                stringsArr !== null
              ) {
                return stringsArr.map((date) => date);
              }
            }
          })
          .flat()
      ),
    ]
      .filter((item) => item !== undefined)
      .map((item) => {
        return {
          name: item,
          isChecked: false,
          order: getMonthOrder(item),
          number: getNumberOfResults(item, "departureMonth"),
        };
      });
    const cities = [
      ...new Set(
        results
          .map((review) => review.includedCities.map((city) => city.name))
          .flat()
      ),
    ].map((item) => {
      return {
        name: item,
        isChecked: false,
        visible: true,
        number: getNumberOfResults(item, "city"),
      };
    });

    const countries = [
      ...new Set(
        results

          .map((review) =>
            review.includedCountries.map((country) => country.name)
          )
          .flat()
      ),
    ].map((item) => {
      return {
        name: item,
        isChecked: false,
        number: getNumberOfResults(item, "country"),
      };
    });

    const regions = [
      ...new Set(
        results
          .map((review) => review.includedRegions.map((region) => region.name))
          .flat()
      ),
    ].map((item) => {
      return {
        name: item,
        isChecked: false,
        number: getNumberOfResults(item, "region"),
      };
    });

    const themes = [
      ...new Set(
        resultsWithThemeTags
          .map((review) =>
            review.themeTags.themeTags.tag.map((tag) => tag.label)
          )
          .flat()
      ),
    ].map((item) => {
      return {
        name: item,
        isChecked: false,
        number: getNumberOfResults(item, "theme"),
      };
    });

    const filterableArtists = {
      title: "Artists",
      isOpen: false,
      checkboxes: artists.sort((a, b) => a.name.localeCompare(b.name)),
    };

    const filterableTourLeaders = {
      title: "Tour Leaders",
      isOpen: false,
      checkboxes: tourLeaders.sort((a, b) => a.name.localeCompare(b.name)),
    };

    const filterableDepartureMonth = {
      title: "Departure Months",
      isOpen: false,
      checkboxes: departureMonths.sort((a, b) => a.order - b.order),
    };

    const filterableCities = {
      title: "Destinations",
      isOpen: false,
      checkboxes: cities.sort((a, b) => a.name.localeCompare(b.name)),
    };

    const filterableCountries = {
      title: "Countries",
      isOpen: false,
      checkboxes: countries.sort((a, b) => a.name.localeCompare(b.name)),
    };

    const filterableThemes = {
      title: "Themes",
      isOpen: false,
      checkboxes: themes.sort((a, b) => a.name.localeCompare(b.name)),
    };

    const filterableRegions = {
      title: "Regions",
      isOpen: false,
      checkboxes: regions.sort((a, b) => a.name.localeCompare(b.name)),
    };

    // Only add to accordion content if there are items in each array then filter out false values
    const filterableData = [
      filterableCountries.checkboxes.length > 0 && filterableCountries,
      filterableRegions.checkboxes.length > 0 && filterableRegions,
      filterableCities.checkboxes.length > 0 && filterableCities,
      filterableTourLeaders.checkboxes.length > 0 && filterableTourLeaders,
      filterableArtists.checkboxes.length > 0 && filterableArtists,
      filterableDepartureMonth.checkboxes.length > 0 &&
        filterableDepartureMonth,
      filterableThemes.checkboxes.length > 0 && filterableThemes,
    ].filter(Boolean);
    // .sort((a, b) => a.title.localeCompare(b.title));

    setFilterableData(filterableData);
  }, [data]);

  const getMinDate = (el) => {
    let datesArr = [];
    el.darwinDepartureDates.map((date) => {
      if (
        (date.departurestatus === "On Sale" ||
          date.departurestatus === "On Request") &&
        new Date(date.landonlydeparturedate).getTime() > new Date().getTime()
      ) {
        datesArr.push(date);
      }
    });
    if (datesArr.length > 0) {
      let arr2 = [
        ...datesArr.map((date) => new Date(date.landonlydeparturedate)),
      ];

      let minDate = datesArr.find(
        (el) =>
          new Date(el.landonlydeparturedate).getTime() === Math.min(...arr2)
      );
      return minDate;
    }
  };

  results.map((el) => {
    if (el.darwinDepartureDates.length > 0) {
      let minDate = getMinDate(el);
      if (minDate?.landonlyadultprice !== undefined) {
        el.offerPrice = minDate.landonlyadultprice;
      } else {
        el.offerPrice = null;
      }
    } else {
      el.offerPrice = null;
    }
    return el;
  });

  return (
    <CulturalTourContent
      page={data.archivePage}
      results={results}
      filterableData={filterableData}
      artists={data.artists.nodes}
      tourLeaders={data.tourLeaders.nodes}
    />
  );
};

export default CulturalTourArchivePage;

/** Attach SEO */
export const Head = ({ data }) => {
  const page = data.archivePage;

  return (
    <Seo
      title={
        page.seoGroup && page.seoGroup.seoMetaTitle
          ? page.seoGroup.seoMetaTitle
          : `${page.name} - Kirker Holidays`
      }
      description={
        page.seoGroup &&
        page.seoGroup.seoMetaDescription &&
        page.seoGroup.seoMetaDescription
      }
      key={page._id}
    />
  );
};

/* GRAPHQL QUERY */
export const query = graphql`
  query ($slug: String!) {
    archivePage: sanityArchivePage(slug: { current: { eq: $slug } }) {
      _id
      _type
      name
      slug {
        current
      }
      cptType
      seoGroup {
        seoMetaTitle
        seoMetaDescription
      }
    }

    culturalTours: allSanityCulturalTour {
      nodes {
        ...SanityCulturalTourFragment
      }
    }
    tourLeaders: allSanityTourLeader {
      nodes {
        ...SanityTourLeaderFragment
      }
    }
    artists: allSanityArtist {
      nodes {
        ...SanityArtistFragment
      }
    }
  }
`;
